<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>选择园点及角色</h1>
      </div>
      <div class="liner"></div>
    </div>

    <div class="main-page">
      <div class="change-role">
        <ul class="list-group-item tinny">
          <li class="list-group" v-for="(item, index) in login_data" @click="selectCurche(index, item)">
            <div class="liner"></div>
            <a class="group-txt clearfix orange" href="javascript:;" v-if="index == cookie_login_data.index">
              <span class="col-xs-8">{{item.curcheName}}</span>
              <span class="col-xs-4">{{item.jobName}}</span>
            </a>
            <a class="group-txt clearfix" href="javascript:;" v-else>
              <span class="col-xs-8">{{item.curcheName}}</span>
              <span class="col-xs-4">{{item.jobName}}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="mid-align" style="width:100vw" v-if="isNoRole">
        <p class="padding-15 margin-15 text-center">
          亲，您还没有加入任何园点<br>快让园长加你为老师吧！
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { service } from '../service'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      auto_login_para: service.setPara('autoLogin'),
      isNoRole: false
    }
  },
  mounted: function () {
    this.autoLogin()
  },
  methods: {
    ...mapMutations([
      'clearVuex'
    ]),
    autoLogin: function () {
      this.auto_login_para.phoneNum = this.cookie_login_data.phoneNum
      this.auto_login_para.curcheId = this.cookie_login_data.curcheId
      this.auto_login_para.teacherToken = this.cookie_login_data.teacherToken

      let that = this
      let obj = {context: that, para: that.auto_login_para, successFun: (response) => {
        if (response.data == null) {
          that.isNoRole = true
          return
        }
        window.localStorage.clear()
        that.login_data = response.data.data
        window.localStorage['login_data'] = JSON.stringify(response.data.data)
        that.cookie_login_data.teacherToken = response.data.teacherToken
        window.localStorage['basic_login_data'] = JSON.stringify(that.cookie_login_data)
      }, not100CodeFun: (response) => {
        if (response.msg == '账号已失效') {
          window.localStorage.clear()
          this.$router.push('/sign')
        }
      }}
      service.request(obj)
    },
    selectCurche: function (index, item) {
      this.cookie_login_data.index = index
      this.cookie_login_data.curcheId = item.curcheId
      this.cookie_login_data.teacherId = item.teacherId
      this.cookie_login_data.jobId = item.jobId
      this.cookie_login_data.teacherIcon = item.teacherIcon
      this.cookie_login_data.baseAcessPath = item.baseAcessPath
      this.cookie_login_data.serviceSchool = item.serviceSchool
      this.jobName = item.jobName
      this.curcheName = item.curcheName
      // $.cookie('login_data', JSON.stringify(this.cookie_login_data), { expires: 7 })
      this.$store.dispatch('clearVuex')
      window.localStorage['basic_login_data'] = JSON.stringify(this.cookie_login_data)
      // window.history.go(-1)
      this.$router.push('/index')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ChooseRole.vue?41ca0d00